import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'

interface AnalyticsData {
  notifications: {
    total: number
    growth_percentage: number
  }
  delivery: {
    rate: string
    delivered_percentage: string
    pending_percentage: string
    failed_percentage: string
  }
  devices: {
    total: number
    active: number
    ios_count: number
    android_count: number
    ios_percentage: number
    android_percentage: number
  }
  live_sessions: {
    total: number
  }
}

export function useAnalytics() {
  return useQuery({
    queryKey: ['analytics'],
    queryFn: () => api.get<AnalyticsData>('/dashboard/analytics'),
    refetchInterval: 60000, // Refresh every minute
  })
}
